import React, { memo, useState, useEffect } from 'react';
import gtmTracking from '@app/utils/gtmTracking';
import Cookies from 'js-cookie';
import Styles from './styles.module.scss';

const ContentCard = ({ isMobile, auth, onClickContentCard }) => {
  const [card, setCard] = useState(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (window.appboy) {
        window.appboy.requestContentCardsRefresh();
        window.appboy.subscribeToContentCardsUpdates((res) => {
          const cards = [...res.cards];
          if (cards && cards.length) {
            const type = isMobile ? 'job_homepage' : 'job_homepage_desktop';
            const data = cards.find(
              (c) => c.extras && c.extras['page'] === type && c.zc === 'ab-banner'
            );
            setCard(data);
          }
        });
      }
    }, 2000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const handleTracking = (e) => {
    e.preventDefault();
    gtmTracking('content_card', card?.url, 'click', {
      page_type: 'job_homepage',
      account_id: auth?.account_id || 'none',
      finger_print: Cookies.get('ctfp') || 'none',
    });
    setTimeout(() => {
      window.location.href = card?.url;
    }, 1000);
  };

  const handleTrackingReferralForm = (e) => {
    e.preventDefault();
    if (onClickContentCard) {
      onClickContentCard();
    }
  };

  const renderBasicCard = () => {
    if (card.extras['referral_form']) {
      return (
        <button
          className={Styles.JobCardWrapper}
          type="button"
          onClick={handleTrackingReferralForm}
        >
          <img src={card?.imageUrl} alt={card?.title || 'appboy'} />
        </button>
      );
    }

    return (
      <div className={Styles.contentCardWrapper}>
        <a href={card?.url} onClick={handleTracking}>
          <img src={card?.imageUrl} alt={card?.title || 'appboy'} />
        </a>
      </div>
    );
  };

  const renderContentCard = () => {
    switch (card.extras['block_id']) {
      case '1':
        return renderBasicCard();
      default:
        return <div />;
    }
  };

  return !card ? null : renderContentCard();
};

export default memo(ContentCard);
